import type { Client } from 'graphql-models';
import type { Factory } from 'walden-fast/types/mocks';

const MOCK_CLIENT: Client = {
  clientNameLocal: 'Local Client',
  clientNameMaster: 'Master Client',
  id: '23839274928',
};

export const clientFactory: Factory<Client> = (overrides) => ({
  ...MOCK_CLIENT,
  ...overrides,
});
